import { Module } from "vuex";
import { getters } from "./getters";
import { IRootState } from "../types";
import { ScoreState } from "./types";
import { actions } from "./actions";

export const state: ScoreState = {};

const namespaced: boolean = true;

export const namespace = "score";

export const score: Module<ScoreState, IRootState> = {
  namespaced,
  state,
  getters,
  actions
};
